export default "__VITE_ASSET__DrnbBNhk__"